import { useContext } from 'react';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useShouldRenderAdArea } from './useShouldRenderAdArea';
import { useAdsType } from './useAdsType';
export function useShouldRenderMobileAdhesion(adSafety) {
    const isMobile = useContext(MobileContext);
    const showAd = useShouldRenderAdArea(adSafety);
    const adsType = useAdsType();
    const ads_mobile_adhesion = useFlag('ads_mobile_adhesion');
    return isMobile && showAd && adsType === 'user' && ads_mobile_adhesion;
}
